import { render, staticRenderFns } from "./Processfield.vue?vue&type=template&id=04bafea2&scoped=true&"
import script from "./Processfield.vue?vue&type=script&lang=js&"
export * from "./Processfield.vue?vue&type=script&lang=js&"
import style0 from "./Processfield.vue?vue&type=style&index=0&id=04bafea2&scoped=true&lang=css&"
import style1 from "./Processfield.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bafea2",
  null
  
)

export default component.exports